import firebase from './../../firebase';
import PropTypes from 'prop-types'; 
import React, { useState,useEffect } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { toastr } from 'react-redux-toastr';
import { Link,  useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';


const LoginForm = ({ hasLabel, layout }) => {
   
  const [l, setL] = React.useState(true); 
  const [ler, setLEr] = React.useState(false); 

  const navigate = useNavigate();

  useEffect(()=> {
    firebase.auth().onAuthStateChanged((user) => {
      if (user)  navigate('/');  
      setL(false)
    })
  })
        
  
  const [loadingUser, setLoadingUser] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  firebase.auth().languageCode = "fr"; 
  const getUser = async (uid, cb) => {
    if (loadingUser){
      return;
    }
    await firebase.firestore()
      .collection("users")
      .doc(uid)
      .get()
      .then(async (docd) => {
        if (docd.exists){

          var user = docd.data();
          user.id = docd.id;
          if (user?.delete){
            firebase.auth().signOut()
            // navigate('/');  
            if (ler){
              return;
            }
            setLEr(true);
            toast.error("Ce compte a été archiver, contactez nous pour plus d'information.");
            setTimeout(() => {
              setLEr(false);
            }, 1000);
          
          }else{
            toast.success(`Connecté avec ${user.email}`, {
              theme: 'colored'
            });
            cb(user);
          }
          
        }else{
          cb(null);
        }
      })
      .catch((error) => {
        console.log("error", error);
        cb(null);
      });
  };

 const logIn = (value) => {
    if (loading) {
      return;
    }
    setLoading(true);
    firebase.auth()
      .signInWithEmailAndPassword(value.email.trim(), value.password.trim())
      .then(async (userCredential) => { 
        const user = userCredential.user; 
        if (!user.emailVerified) {
          user.sendEmailVerification();
          console.log("Email de vérification envoyé !");
          firebase.auth().signOut();
          alert("Veuillez vérifier votre email avant de continuer.");
        } else {
          setLoading(false); 
          console.log("Connexion réussie !"); 
          await sendVerificationCode(user.email); 
        }
        //redirection automatique
      })
      .catch((err) => {
        setLoading(false);
        //do something with the error
        console.log(err);
        // alert(getTranslation(err.code));
        toast.error("Identifiant invalide");
      });
  };

  const redirection = (user) => {
    const redi = localStorage.getItem("redirectAfterlogin");
    if (redi) {
      window.location.href = redi;
      localStorage.removeItem("redirectAfterlogin");
      return;
    }

    switch (user?.role) { 

      default:
        // redirection à l'accueil 
        navigate('/'); 
        break;
    }
  };

  const verifyCode = async (email, code) => {
    try {
      const verify = firebase.functions().httpsCallable("verifyCode") ;
      await verify({ email, code });
      // console.log(result.data.message);
      // Accès accordé
      toast.success("Accès accordé");
    } catch (error) {
      console.error("Erreur :", error.message);
      firebase.auth().signOut();
      toast.error("Code incorrect ou expiré, déconnexion");
    }
  }; 

  
  const sendVerificationCode = async (email) => {
    try {
      const sendCode = firebase.functions().httpsCallable("sendVerificationCode") 
      await sendCode({ email });
      // console.log(result.data.message); 
      const userInput = prompt("Veuillez entrer votre code de vérification dans votre boite d'email :");

      if (userInput !== null) {
        await verifyCode(email, userInput);
        // alert(`Vous avez saisi le code : ${userInput}`);
      } else {
        toast.error('Déconnexion, code invalide');
        firebase.auth().signOut();
      }
    } catch (error) {
      console.error("Erreur :", error); 
    }
  };
 

  useEffect(() => {
    // check if user is login
    setLoadingUser(true);
    firebase.auth().onAuthStateChanged(async (u) => {
      if (u) {  
        if (!u.emailVerified) {
          await u.sendEmailVerification();
         console.log("Email de vérification envoyé !");
          firebase.auth().signOut();
          alert("Veuillez vérifier votre email avant de continuer.");
        } else {
          setLoading(false); 
          console.log("Connexion réussie !");
        }
        if (loadingUser){
          return;
        }
        setLoadingUser(true);
        //redirection au compte
        getUser(u.uid, (user) => {
          setLoadingUser(false);
          // console.log("user", user);
          firebase.auth().languageCode = "fr";
          redirection(user);
        });
      } else {
        setLoadingUser(false);
      }
    });
    setTimeout(() => {
      setLoadingUser(false); 
    }, 5000);
  }, []);

  // State
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    remember: false
  });

  // Handler
  const handleSubmit = e => {
    e.preventDefault();
    // console.log(formData);
    logIn(formData)
  };

  const handleFieldChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <>{!l && (<Form onSubmit={handleSubmit}>
 
      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Adresse email</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? 'Adresse email' : ''}
          value={formData.email}
          name="email"
          onChange={handleFieldChange}
          type="email"
        />
      </Form.Group>

      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Mot de passe</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? 'Mot de passe' : ''}
          value={formData.password}
          name="password"
          onChange={handleFieldChange}
          type="password"
        />
      </Form.Group>

      <Row className="justify-content-between align-items-center">
        {/* <Col xs="auto">
          <Form.Check type="checkbox" id="rememberMe" className="mb-0">
            <Form.Check.Input
              type="checkbox"
              name="remember"
              checked={formData.remember}
              onChange={e =>
                setFormData({
                  ...formData,
                  remember: e.target.checked
                })
              }
            />
            <Form.Check.Label className="mb-0 text-700">
              Se souvenir de moi
            </Form.Check.Label>
          </Form.Check>
        </Col> */}

        <Col xs="auto">
          <Link
            className="fs--1 mb-0"
            to={`/authentication/${layout}/forgot-password`}
          >
            Mot de passe oublié?
          </Link>
        </Col>
      </Row>

      <Form.Group>
        <Button
          type="submit"
          color="primary"
          className="mt-3 w-100"
          disabled={loading || !formData.email || !formData.password}
        >
          Connexion
        </Button>
      </Form.Group>

      {/* <Divider className="mt-4">or log in with</Divider> */}

      {/* <SocialAuthButtons /> */}
    </Form>)}
    </>
  );
};

LoginForm.propTypes = {
  layout: PropTypes.string,
  hasLabel: PropTypes.bool
};

LoginForm.defaultProps = {
  layout: 'simple',
  hasLabel: false
};

export default LoginForm;
